<template>
    <div>
        <div class="card bg-light mb-0">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Work Experience</h6>
            </div>
            <div class="card-body bg-white position-relative">
                <b-row align-v="center" class="loader" v-if="is_saving">
                    <b-col>
                        <b-spinner></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </b-col>
                </b-row>
                <b-form @submit.prevent="save">
                    <b-form-group label="Company Name:" description="This field is required">
                        <b-form-input v-model="form.company" type="text" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Job Title:" description="This field is required">
                        <b-form-input v-model="form.job_title" type="text" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="From Date:" description="This field is required">
                        <b-form-input v-model="form.from" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="To Date:" description="This field is required">
                        <b-form-input v-model="form.to" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <div class="text-right mt-3">
                        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
        mixins:[SwalMixin],
        data() {
            return {
                is_saving:false,
                form:{
                    id:-1,
                    company:'',
                    job_title:'',
                    from:'',
                    to:''
                },
            }
        },

        created(){
        },
        methods: {
            save() {
                this.swalConfirmSubmit((data) => {
                    if (data.value) {
                        this.is_saving = true;
                        this.form.manpower_id = this.$route.params.id;
                        this.axios.post('maintenance/manpowers/work-experiences/save', this.form).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving = false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving = false;
                        });
                    }
                });
            },
        }
    }
</script>
